<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Agregar Album`,
        },
      ]"
    />
    <div v-if="loading" class="text-center">
      <Loader />
    </div>

    <div v-else>
      <div class="card ml-3 mr-3 mt-3">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3">
              <button class="btn main-bg" @click="saveMedia">Guardar</button>
            </div>
            <div class="col-sm-3">
              <!-- LATITUD -->
              <div class="form-group">
                <label>Nombre album</label>
                <input type="text" v-model="title" :class="`form-control `" />
              </div>
            </div>
            <div class="col-sm-6">
              <label>Imagen de portada</label>
              <div class="card mb-3" style="width: 80%; height: 272px">
                <img
                  v-if="albumFile"
                  @click="handleFileChangeAlbum"
                  class="card-img-top"
                  :src="getMediaUrl(albumFile)"
                  style="width: 100%; height: 200px; cursor: pointer"
                />
                <img
                  v-else
                  @click="handleFileChangeAlbum"
                  class="card-img-top"
                  src="../../assets/no_image.png"
                  style="width: 100%; height: 272px; cursor: pointer"
                />

                <div class="card-body">
                  <button
                    v-if="albumFile"
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="removeMediaAlbum()"
                  >
                    Eliminar
                  </button>
                  <input
                    type="file"
                    class="custom-file-input"
                    ref="fileInputAlbum"
                    @change="handleFileChangeAlbum"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- aqui van las medias img-->
      <div class="card ml-3 mr-3 mt-3">
        <label class="ml-3 mt-3 title">Imagenes</label>
        <div class="card-body">
          <div class="row">
            <div
              class="col-md-4"
              v-for="(media, index) in mediaList"
              :key="index"
            >
              <div
                class="card mb-3"
                style="width: 80%; height: 272px"
                @change="handleFileChange(index)"
              >
                <img
                  v-if="media.file"
                  @click="handleFileChange(index)"
                  class="card-img-top"
                  :src="getMediaUrl(media.file)"
                  style="width: 100%; height: 200px"
                />
                <img
                  v-else
                  @click="handleFileChange(index)"
                  class="card-img-top"
                  src="../../assets/no_image.png"
                  style="width: 100%; height: 200px; cursor: pointer"
                />

                <div class="card-body">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="removeMedia(index)"
                  >
                    Eliminar
                  </button>
                  <input
                    type="file"
                    class="custom-file-input"
                    ref="fileInput"
                  />
                  <!-- <label class="custom-file-label" v-if="media.file">{{
                    media.file.name
                  }}</label>
                  <label class="custom-file-label" v-else>Choose file</label> -->
                </div>
              </div>
            </div>
          </div>

          <button class="btn btn-primary mt-5" @click="addMedia">
            AGREGAR
          </button>
        </div>
      </div>
      <!-- aqui van las medias video-->
      <div class="card ml-3 mr-3 mt-3">
        <label class="ml-3 mt-3 title">Videos</label>
        <div class="card-body">
          <div class="row">
            <div
              class="col-md-4"
              v-for="(media, index) in mediaVideoList"
              :key="index"
            >
              <div
                class="card mb-3"
                style="width: 80%; height: 272px"
                @change="handleFileChangeVideo(index)"
              >
                <img
                  v-if="media.file"
                  @click="handleFileChangeVideo(index)"
                  class="card-img-top"
                  src="../../assets/video.jpg"
                  style="width: 100%; height: 200px"
                />
                <img
                  v-else
                  @click="handleFileChangeVideo(index)"
                  class="card-img-top"
                  src="../../assets/no_image.png"
                  style="width: 100%; height: 200px; cursor: pointer"
                />

                <div class="card-body">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="removeMediaVideo(index)"
                  >
                    Eliminar
                  </button>
                  <input
                    type="file"
                    class="custom-file-input"
                    ref="fileInputVideo"
                  />
                </div>
              </div>
            </div>
          </div>

          <button class="btn btn-primary mt-5" @click="addMediaVideo">
            AGREGAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import { UtilsService } from "../../services/UtilsService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  components: {
    Loader,
    Breadcrumbs,
  },
  data() {
    return {
      mediaList: [], // Initial media list with one empty item
      mediaVideoList: [],
      albumFile: null,
      companyService: new CompanyService(),
      utilService: new UtilsService(),
      title: "",
      loading: false,
    };
  },
  methods: {
    addMedia() {
      this.mediaList.push({ file: null });
    },
    addMediaVideo() {
      this.mediaVideoList.push({ file: null });
    },
    removeMedia(index) {
      this.mediaList.splice(index, 1);
    },
    removeMediaVideo(index) {
      this.mediaVideoList.splice(index, 1);
    },
    removeMediaAlbum() {
      this.albumFile = null;
    },

    handleFileChange(index) {
      this.$refs.fileInput[index].click();
      const input = this.$refs.fileInput[index];
      if (input && input.files.length > 0) {
        this.$set(this.mediaList, index, { file: input.files[0] });
      }
    },
    handleFileChangeVideo(index) {
      this.$refs.fileInputVideo[index].click();
      const input = this.$refs.fileInputVideo[index];
      if (input && input.files.length > 0) {
        this.$set(this.mediaVideoList, index, { file: input.files[0] });
      }
      console.log("fileVideodesde handle:", this.mediaVideoList);
    },

    handleFileChangeAlbum() {
      this.$refs.fileInputAlbum.click();
      const input = this.$refs.fileInputAlbum;
      if (input && input.files.length > 0) {
        this.albumFile = input.files[0];
      }
    },

    getMediaUrl(file) {
      return URL.createObjectURL(file);
    },
    async saveMedia() {
      try {
        if (
          (this.mediaList.length > 0 && this.albumFile != null) ||
          (this.mediaVideoList.length > 0 && this.albumFile != null)
        ) {
          this.loading = true;
          let documentsArray = [];
          let documentsArrayVideo = [];
          if (this.mediaList.length > 0) {
            for (const element of this.mediaList) {
              let fileBase64 = await this.fileToBase64(element.file);
              let url = await this.utilService.uploadFile(
                element.file.name,
                fileBase64
              );
              documentsArray.push({
                documentName: element.file.name,
                url: url,
              });
            }
          }
          if (this.mediaVideoList.length > 0) {
            for (const element of this.mediaVideoList) {
              console.log("file", element);
              let fileBase64 = await this.fileToBase64(element.file);

              let url = await this.utilService.uploadFile(
                element.file.name,
                fileBase64
              );
              documentsArrayVideo.push({
                documentName: element.file.name,
                url: url,
              });
            }
          }

          let galeryBase64 = await this.fileToBase64(this.albumFile);
          const galeryData = {
            documentName: this.albumFile.name,
            title: this.title,
            fileObj: galeryBase64,
          };
          const data = {
            documents: documentsArray,
            videos: documentsArrayVideo,
            galery: galeryData,
          };

          const res = await this.companyService.addAdvertising(
            JSON.stringify(data)
          );
          console.log("Respuesta", res);

          if (res.ok) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Se ha guardado la publicidad correctamente.",
              showConfirmButton: false,
              timer: 1500,
            });
            this.$router.go(-1);
          } else {
            this.$helpers.message("Error", res.message, "error");
          }
        }
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
        this.loading = false;
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.split(",")[1]);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    },
  },
};
</script>

<style>
/* Add custom styles here if needed */
</style>
